import { identitySystemCls, identitySystemClsLocalization } from 'constants/cls';
import { ClsItem } from 'types/clsType';

export const getClsItemCaption = (clsItem: ClsItem): string => clsItem.term ?? '';

export const clsItemEquals = (a: ClsItem, b: ClsItem): boolean => a.num === b.num;

export const getIdentifierTitle = (cIdentSystem: string): string => {
  const pair = Object.entries(identitySystemCls).find((identifier) => identifier[1] === cIdentSystem);
  return pair ? identitySystemClsLocalization[pair[0] as keyof typeof identitySystemCls] : 'data';
};

export const idOnly = (idWithPrefix: string): string => idWithPrefix?.split(':')[1];
